import { useEffect, useContext } from "react";

// Dependencies
// Components
import ContentTemplate from "../../ContentTemplate";
// Context
import { StageContext } from "../../../Module/Stage/ModuleStage";
// Styles
import { TextMark } from "../../../Styles/index";
import styled from "styled-components";

export default function Electrocardiogram(props) {
  const contextValue = useContext(StageContext);
  const {
    setActiveMark,
    setActiveMarkData,
    activeMark,
    clickTextMark,
  } = contextValue;

  const loadMarkData = [
    {
      id: 0,
      img: "https://medzcool-images.s3.amazonaws.com/Normal-EKG.png",
    },
    {
      id: 1,
      img: "https://medzcool-images.s3.amazonaws.com/EKG-waves-bumps.png",
    },
  ];
  useEffect(() => {
    setActiveMark(0);
    setActiveMarkData(loadMarkData);
  }, []);

  return (
    <ContentTemplate>
      <p>
        The electrocardiogram (EKG) records the electrical activity of the
        heart. It is{" "}
        <TextMark
          activeMark={activeMark == 0 && true}
          onClick={() => clickTextMark(0)}>
          recorded
        </TextMark>{" "}
        on graph paper and can provide information about the heart's function
        and structure.
      </p>
      <p>
        Clinicians can use the EKG to monitor cardiac health and diagnose
        various pathology.
      </p>
      <p>
        The{" "}
        <TextMark
          activeMark={activeMark == 1 && true}
          onClick={() => clickTextMark(1)}>
          waves and bumps
        </TextMark>{" "}
        you see on the EKG represent electrical activity moving through the
        heart, which can correlate to the different stages of the cardiac cycle
        and cardiac contraction.
      </p>
    </ContentTemplate>
  );
}

const RateBlock = styled.div`
  margin-top: 35px;
  margin-bottom: 35px;
  ul {
    margin-top: 10px;
  }
`;
